import type { InternalErrorResponse } from '@/services/transport/types'
import type { ValidationRuleErrorWithRuleName } from '@/services/validation/types'
import type { Dict } from '@/types'

export const STATELESS_FORM_KEY = Symbol('STATELESS_FORM_KEY')

export interface IControl {
  validate(): Promise<boolean>
  getName(): string
  getValue(): any
  getErrors(): ValidationRuleErrorWithRuleName[]
  resetErrors(): void
  getRulesResults(): Dict<boolean>
  reset(): void
  touch(): void
  isTouched(): boolean
  shouldShowErrors(): boolean
  focus?(): void
  handleBlur(): void
  destroy?(): void
}

export interface IStatelessForm<T = Record<string, unknown>> {
  getId(): string
  name: string
  register(control: IControl): void
  unregister(control: IControl): void
  validate(): Promise<boolean>
  reset(): void
  getFormData(): T
  getErrors(): ValidationRuleErrorWithRuleName[]
  getValidationRulesResults(): Dict<boolean>
  touchAll(): void
  focusFirstInvalidField(): Promise<void>
  getControlsWithErrors(): IControl[]
  submit?(values: T): Promise<unknown>
  processServerErrors(errors: InternalErrorResponse, controlName?: string): Dict<string[]>
}
